import type { Appointments } from "@/lib/appointments"
import { buildServicesCollection } from "@/lib/services/buildCollection"

export const buildAppointmentsCacheStore = (
  overrides?: Partial<Appointments.OfferingsCache.Store>
): Appointments.OfferingsCache.Store => {
  return buildServicesCollection(overrides)
}
